<template>
    <component
        ref="component"
        :is="componentType"
        :form-data="formData"
        :options="options"
        :data="data"
    ></component>

    <validation-row
        ref="validation"
        :validation-data="validationData"
        :name="formData.validationName ? formData.validationName : formData.name"
        :show-label="showValidationLabel()"
        :no-margin="!! options.noMargin"
        :less-margin="!! options.lessMargin"
        v-if="! options.noValidation"
    ></validation-row>
</template>

<script>

    import ValidationRow from './ValidationRow.vue';

    export default {

        name: "Group",

        props: ['category', 'formData', 'options', 'data', 'validationData'],

        components: {
            'validation-row': ValidationRow,
        },

        data() {
            return {
                isLoading: true,
                componentType: null,
            }
        },

        created() {
            if (this.options && this.options.exactName) {
                this.componentType = this.category;
            } else {
                this.componentType = 'form-group-' + this.category;
            }
        },

        methods: {

            stopLoading() {

                //TODO: too complicated, no time, do it later
                // this.isLoading = false;
                // const referenceLoader = document.querySelector('[data-reference="form-loader-' + this.formData.name + '"]');
                // referenceLoader.classList.add('hidden');
            },

            showValidationLabel() {
                return this.hasLabel() && typeof this.options.column === 'undefined';
            },

            hasLabel() {
                return this.formData.label && this.formData.label !== ' ';
            }
        }
    }
</script>

<style scoped>

</style>
